<template>
    <div class="qr-codes">
        <div class="flex flex-column gap-4 align-items-center">
            <div class="header">{{ $t('message.horseEdit.documents.qrCodeStudbookLabel') }}</div>
            <qrcode-vue ref="qrEditHorseSvg" :value="qrEditHorseUrl" :size="qr_size" level="H" render-as="svg" />
            <div><CustomTextButton :label="$t('message.horseEdit.documents.qrCodeDownloadButton')"
                @click="downloadSvg('qrEditHorseSvg', getEditSvgFileName)"/></div>
        </div>
        <div class="flex flex-column gap-4 align-items-center">
            <div class="header">{{ $t('message.horseEdit.documents.qrCodeProfileLabel') }}</div>
            <qrcode-vue ref="qrLabHorseDetails" :value="qrLabHorseUrl" :size="qr_size" level="H" render-as="svg"/>
            <div><CustomTextButton :label="$t('message.horseEdit.documents.qrCodeDownloadButton')"
                @click="downloadSvg('qrLabHorseDetails', getLabSvgFileName)"/></div>
        </div>
    </div>
</template>

<script>
import QrcodeVue, { QrcodeCanvas, QrcodeSvg } from "qrcode.vue";
import CustomTextButton from "@/components/form/CustomTextButton.vue";
import QrScanner from "@/views/pending/components/QrScanner.vue";
import {FileUtils} from "@/utils/FileUtils";

export default {
    name: "HorseEditDocumentQRCodes",

    components: {
        QrScanner,
        CustomTextButton,
        QrcodeVue,
        QrcodeCanvas,
        QrcodeSvg,
    },

    props: {
        horse: null,
    },

    computed: {
        qrEditHorseUrl() {
            return process.env.VUE_APP_APP_URL + "/horse/edit/" + this.horse.id;
        },
        qrLabHorseUrl() {
            return process.env.VUE_APP_APP_URL + "/laboratory/horses/form/" + this.horse.id;
        },
        getLabSvgFileName() {
            return  FileUtils.toSafeFileName(this.horse.name + "_lab_qr_code", "svg", "qrCodeLabHorseDetails")
        },
        getEditSvgFileName() {
            return  FileUtils.toSafeFileName(this.horse.name + "_edit_page_qr_code", "svg", "qrCodeLabHorseDetails")
        }
    },

    data() {
        return {
            qr_value: "https://example.com",
            qr_size: 200,
            qr_download_size: 512,
        };
    },

    methods: {
        downloadSvg(refName, fileName) {
            const qrComponent = this.$refs[refName];

            let svgElement = qrComponent.$el;
            if (svgElement.nodeName.toLowerCase() !== "svg") {
                svgElement = svgElement.querySelector("svg");
            } else {
                console.error("SVG element not found!");
            }

            const clonedSvg = svgElement.cloneNode(true);

            // Update the width and height attributes to the desired download size
            if (this.qr_download_size) {
                clonedSvg.setAttribute("width", this.qr_download_size);
                clonedSvg.setAttribute("height", this.qr_download_size);
            }

            const serializer = new XMLSerializer();
            const svgData = serializer.serializeToString(clonedSvg);

            const blob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    },
};
</script>

<style lang="scss" scoped>
.qr-codes {
    max-width: 200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .header {
        font-size: 1.3rem;
        font-weight: 500;
        text-align: center;
    }
}
</style>
